import { jsx } from "react/jsx-runtime";
import { forwardRef, useEffect, useState } from "react";
import Search from "@crehana/compass.icons.outline/Search";
import { createFormFieldId } from "../helpers/createFormFieldId.js";
import { InputField } from "../InputField/index.js";
import CloseIcon from "./components/CloseIcon.js";
const SearchField = /*#__PURE__*/ forwardRef(({ onSearch, onChange, onClearButtonClick, defaultValue, value, id, label, ...inputFieldProps }, ref)=>{
    const [controlledValue, setControlledValue] = useState(value || defaultValue || '');
    const inputId = createFormFieldId({
        id,
        label
    });
    const handleChange = (event)=>{
        if (onChange) onChange(event);
        if (onSearch) onSearch(event.target.value);
        setControlledValue(event.target.value);
    };
    const clearSearch = ()=>{
        setControlledValue('');
        if (onClearButtonClick) onClearButtonClick();
        const input = document.getElementById(`${inputId}`);
        if (!input) return;
        input.value = '';
        input.dispatchEvent(new Event('change', {
            bubbles: true
        }));
    };
    useEffect(()=>{
        if (void 0 !== value) setControlledValue(value);
    }, [
        value
    ]);
    return /*#__PURE__*/ jsx(InputField, {
        ref: ref,
        id: inputId,
        label: label,
        onChange: handleChange,
        value: controlledValue,
        leadingIcon: Search,
        trailingElement: controlledValue && !inputFieldProps.disabled ? /*#__PURE__*/ jsx(CloseIcon, {
            onClick: clearSearch
        }) : void 0,
        ...inputFieldProps
    });
});
SearchField.displayName = 'SearchField';
const SearchField_SearchField = SearchField;
export default SearchField_SearchField;
export { SearchField };
